import { axiosInstanceUnauth } from "./setup/axiosInstance";

const withdrawalsAPI = {
    getAdminWithdrawals: async (token) => {
        return axiosInstanceUnauth.get('/api/v1/withdrawal/manual/admin/all', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            return res.data;
        }).catch((error) => {
            console.error('getAdminWithdrawals Failed:', error);
            return Promise.reject(error.response || error.message);
        });
    },

    updateStatus: async (id, status, token) => {
        return axiosInstanceUnauth.post(`/api/v1/withdrawal/manual/admin/${id}/status?status=${status}`, null, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            return res.data;
        }).catch((error) => {
            console.error('updateStatus Failed:', error);
            return Promise.reject(error.response || error.message);
        });
    },

    getUsersDetails: async (userIds, token) => {
        return axiosInstanceUnauth.post('/api/v1/accounts/admin/details', userIds, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            return res.data;
        }).catch((error) => {
            console.error('getUsersDetails Failed:', error);
            return Promise.reject(error.response || error.message);
        });
    }
};

export default withdrawalsAPI;